import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { forgot } from '../../service/api';

import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import LoadingEllipsis from '../../components/LoadingEllipsis/LoadingEllipsis';
import './styles/Forgot.css';

import bckgVideo from '../../assets/video/oranges.mp4';

const Forgot = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const [currentYear] = useState(new Date().getFullYear());
  const timeoutRef = useRef(null);

  const formik = useFormik({
    initialValues: { email: '' },
    validationSchema: Yup.object({
      email: Yup.string().email('Email inválido').required('Email obrigatório'),
    }),
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        const message = await forgot(values.email);
        setMessage(message);
        resetForm();
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          typeof error.response.data === 'string' &&
          error.response.data.includes('registrado com Google/Facebook')
        ) {
          setMessage(error.response.data);
          setTimeout(() => {
            navigate('/login');
          }, 4000);
        } else {
          console.error('forgot error:', error);
          setMessage(error.response?.data?.message || 'Erro ao processar seu email');
        }
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (message) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setMessage(''), 4000);
    }
  }, [message]);


  return (
    <>
      <div className="forgotVideoBox">
        <video src={bckgVideo} muted autoPlay loop />
      </div>

      <div className='forgot-container'>
        <div className="forgotBox">
          <div className="forgotTitle">
            <span>Digite seu email cadastrado</span>
          </div>
          <Form onSubmit={formik.handleSubmit}>
            {loading && <div className="message"> <LoadingEllipsis message="Aguarde" /> </div>}
            {message && <div className="message"> {message} </div>}

            <Form.Group>
              <Form.Label htmlFor="email">Email</Form.Label>
              <Form.Control
                size="sm"
                type="email"
                id="email"
                name="email"
                autoComplete="email"
                placeholder="Digite seu email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.email && formik.errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="forgotBtn">
              <Button className="form-btn btn" variant="primary" type="submit">
                Enviar
              </Button>
            </Form.Group>
            <div className="exitLink">
              <a href="/">sair</a>
            </div>
          </Form>
        </div>
      </div>

      <div className="footerLogin">
        <div className='year'>2007 - <span>{currentYear}</span></div>
        <div>&copy; todos os direitos reservados</div>
        <div>powered by <span className='brand'>apit solutions</span></div>
      </div>
    </>
  );
};

export default Forgot;
